/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import common from "@api/common";
import {loading, message} from "heyui.ext";
import {jsPDF} from "jspdf";

let fontContent;
const FontLoader = (doc) => {
	return new Promise((resolve) => {
		if (fontContent) {
			resolve(fontContent)
		} else {
			loading("打印字体准备中,请稍后...")
			let lastLoaded = 0;
			let lastTime = Date.now();
			
			common.pdfFont({
				onDownloadProgress: (e) => {
					// 处理可能缺失 total 的情况
					const total = e.total || 1;
					const loaded = e.loaded || 0;
					
					// 计算下载速度
					const now = Date.now();
					const timeDiff = now - lastTime;
					const bytesDiff = loaded - lastLoaded;
					
					if (timeDiff > 500) { // 每500ms更新一次
						const speed = bytesDiff / (timeDiff / 1000); // B/s
						const speedText = speed > 1024 
						? `${(speed / 1024).toFixed(1)} KB/s` 
						: `${Math.round(speed)} B/s`;
						
						if (total > 1) {
							const percent = (loaded / total * 100).toFixed(1);
							loading(`打印字体准备中... ${percent}% (${speedText})`);
						} else {
							loading(`打印字体准备中... ${loaded} 字节已下载 (${speedText})`);
						}
						
						lastLoaded = loaded;
						lastTime = now;
					}
				}
			}).then((blob) => {
				blob.text().then((font) => {
					fontContent = font;
					resolve(font)
				}).catch(() => {
					message.error("字体加载失败😭,请重试~")
				}).finally(() => loading.close());
			})
		}
	})
}

const DEFAULT_OPT = {
	orientation: 'p',
	unit: 'mm',
	putOnlyUsedFonts: true,
	floatPrecision: 2 // or "smart", default is 16
};

jsPDF.API.print = function (filename) {
	this.output('dataurlnewwindow', {filename})
}
/**
 * A4（16k）297mm×210mm；
 *
 * A5（32k）210mm× 148mm；
 * @param options
 * @returns {Promise<unknown>}
 */
const print = (options = {},size = '') => {
	let customFormat = 'a4';
	if (size === 'big') {
		customFormat = [210, 360]; // 自定义尺寸
	}
	const finalOptions = {
		...DEFAULT_OPT, // 保留默认配置
		...{ format: customFormat }, // 覆盖 format
		...options // 再合并外部传入的 options
	};
	const doc = new jsPDF(finalOptions);
	return new Promise((resolve) => {
		FontLoader(doc).then((font) => {
			doc.addFileToVFS('simsun-normal.ttf', font);
			doc.addFont('simsun-normal.ttf', 'simsun', 'normal');
			doc.addFont('simsun-normal.ttf', 'simsun', 'bold');
			doc.setFont('simsun');
			doc.setLineHeightFactor(1)
			resolve(doc);
		})
	})
}

export default {print}
